// actions/commonActions.js
import { SHOW_MESSAGES, CLEAR_MESSAGES } from "../constants/ActionsTypes";

export const showMessages = (messages) => {
  return {
    type: SHOW_MESSAGES,
    payload: messages,
  };
};

export const clearMessages = () => {
  return {
    type: CLEAR_MESSAGES,
  };
};
